export const PROMOS_LOADED = 'Promos/PROMOS_LOADED';
